import React from "react";
import { MessageSquarePlus } from "lucide-react";
import { formatPeso } from "../../lib/utils";
import { nActions } from "../../lib/opportunityApi";

const php = (v) => formatPeso(v, { compact: true });

function Rows({ title, rows, kind, onAsk, testid, f }) {
  const top = Math.max(...rows.map(r => r.value), 1);
  const q = (r) => (kind === "branch" ? `Why is ${r.name} so high?` : `What is driving ${r.name}?`);
  return (
    <div className="min-w-0">
      <div className="kpi-label text-[10px] mb-2">{title}</div>
      <ul className="space-y-2" data-testid={testid}>
        {rows.map(r => (
          <li key={r.code} data-testid={`${testid}-${r.code}`} className="group">
            <div className="flex items-baseline justify-between gap-2 text-[12.5px]">
              <span className="min-w-0 truncate font-medium" title={r.name}>{r.name}</span>
              <span className="font-mono-tabular font-semibold shrink-0">{php(r.value)}</span>
            </div>
            <div className="mt-1 h-1.5 rounded-sm bg-surface-2 overflow-hidden"><div className="h-full bg-primary/70" style={{ width: `${(100 * r.value) / top}%` }} /></div>
            <div className="mt-1 flex items-center justify-between gap-2 text-[10.5px] text-muted">
              <span className="truncate">{r.code} · {nActions(r.count)} · {r.share}%{kind === "branch" ? ` · mostly ${r.top_engine}` : `${f.branch_scope ? "" : ` · ${r.branches} branch${r.branches === 1 ? "" : "es"}`} · ${r.engines.length} engine${r.engines.length === 1 ? "" : "s"}`}</span>
              {onAsk && (
                <button type="button" data-testid={`${testid}-${r.code}-ask`} onClick={() => onAsk(q(r))} title={q(r)}
                        className="shrink-0 inline-flex items-center gap-1 text-primary hover:underline">
                  <MessageSquarePlus size={11} /> Ask
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

// Where the total sits: the branches and SKUs that carry most of it (tap Ask to drill in with a follow-up).
export function OpportunityWhere({ f, onAsk }) {
  return (
    <section data-testid="opp-where" className="space-y-3">
      <h3 className="font-display text-[15px] font-semibold tracking-tight">Where it sits</h3>
      {f.branch_scope && <p className="text-[12px] text-muted">Every action here involves {f.branch_name || f.branch_scope}, including transfers it sends to other branches.</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {!f.branch_scope && <Rows title="Top branches" rows={f.branches} kind="branch" onAsk={onAsk} testid="opp-branches" f={f} />}
        <Rows title="Top SKUs" rows={f.skus} kind="sku" onAsk={onAsk} testid="opp-skus" f={f} />
      </div>
    </section>
  );
}
